module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1190.a083f8f8.png";